export const formatAuthCookieDomain = (rawDomain: string): string | undefined => {
  if (!rawDomain) return undefined;
  if (rawDomain.startsWith(".")) {
    return rawDomain;
  }

  return `.${rawDomain}`;
};
